import React, { useState } from 'react';
import Autosuggest from 'react-autosuggest';
import { calculateDistance } from '../utils/Fetching';

function DistanzRechner() {
    const [origin, setOrigin] = useState('');
    const [destination, setDestination] = useState('');
    const [mode, setMode] = useState<'Auto' | 'Bahn' | 'Fahrrad'>('Auto');
    const [distance, setDistance] = useState<string | null>(null);
    const [suggestions, setSuggestions] = useState<Place[]>([]);

    type Place = { alias: string, fullName: string };

    const predefinedPlaces: Place[] = [
        { alias: 'BTB', fullName: 'BTB Gmbh, Leinfelden-Echterdingen' },
        { alias: 'Böblingen', fullName: 'Böblingen' },
        { alias: 'Stuttgart', fullName: 'Stuttgart' },
        { alias: 'ADV', fullName: 'Akademie für Datenverarbeitung, Böblingen' },
        { alias: 'DSV', fullName: 'Am Wallgraben 115, 70565 Stuttgart'}
    ];

    const replace = (text: string) => {
        return text
            .replace(/ä/g, 'ae')
            .replace(/ö/g, 'oe')
            .replace(/ü/g, 'ue')
            .replace(/Ä/g, 'Ae')
            .replace(/Ö/g, 'Oe')
            .replace(/Ü/g, 'Ue');
    };

    const berechnen = async () => {
        try {
            const modeMapping: { [key in typeof mode]: string } = {
                Auto: 'driving',
                Bahn: 'transit',
                Fahrrad: 'bicycling',
            };
            const selectedMode = modeMapping[mode];
            const originPlace = predefinedPlaces.find(place => place.alias === origin);
            const destinationPlace = predefinedPlaces.find(place => place.alias === destination);
            const convertedOrigin = replace(originPlace ? originPlace.fullName : origin);
            const convertedDestination = replace(destinationPlace ? destinationPlace.fullName : destination);
            
            const distanceAsString = await calculateDistance({
                origin: convertedOrigin,
                destination: convertedDestination,
                mode: selectedMode as 'driving' | 'transit' | 'bicycling'
            });

            setDistance(distanceAsString);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const getSuggestions = (value: string) => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        return inputLength === 0 ?
            []
            :
            predefinedPlaces.filter(
                place => place.alias.toLowerCase().slice(0, inputLength) === inputValue
            );
    };

    const onSuggestionsFetchRequested = ({ value }: { value: string }) => {
        setSuggestions(getSuggestions(value));
    };

    const onSuggestionsClearRequested = () => {
        setSuggestions([]);
    };

    return (
        <div>
            <div className="divider-light" />
            <div className="distanzrechner">
                <span>Distanzrechner: </span>
                <select
                    className="distanzrechner-input"
                    value={mode}
                    onChange={e => setMode(e.target.value as 'Auto' | 'Bahn' | 'Fahrrad')}
                >
                    <option value="Auto">Auto</option>
                    <option value="Bahn">Bahn</option>
                    <option value="Fahrrad">Fahrrad</option>
                </select>

                <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={onSuggestionsClearRequested}
                    getSuggestionValue={suggestion => suggestion.alias}
                    renderSuggestion={suggestion => <div>{suggestion.alias}</div>}
                    inputProps={{
                        placeholder: 'Startadresse',
                        value: origin,
                        onChange: (_, { newValue }) => setOrigin(newValue),
                    }}
                />

                <span>→</span>

                <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={onSuggestionsClearRequested}
                    getSuggestionValue={suggestion => suggestion.alias}
                    renderSuggestion={suggestion => <div>{suggestion.alias}</div>}
                    inputProps={{
                        placeholder: 'Zieladresse',
                        value: destination,
                        onChange: (_, { newValue }) => setDestination(newValue),
                    }}
                />

                <button className="berechnen-button" onClick={berechnen}>
                    Berechnen
                </button>
            </div>
            <div className={`ergebnis ${distance !== null ? '' : 'hidden'}`}>
                <p>Distanz: {distance}</p>
            </div>
        </div>
    );
}

export default DistanzRechner;